import { Injectable, signal } from '@angular/core';
import { CrewInfo } from 'src/app/models/CrewInfo';
import { ValidateCrewInfo } from 'src/app/models/ValidateCrewInfo';
import { CREW_INFO, getItemFromSessionStorage, setItemInSessionStorage } from 'src/app/utils/SessionStorageUtil';

/**
 * Fuente única y reactiva del estado del tripulante.
 * Reemplaza las lecturas por getter de sessionStorage (causa de NG0100):
 * los signals notifican a Angular qué vistas deben refrescarse.
 */
@Injectable({ providedIn: 'root' })
export class CrewInfoStore {

  private readonly _crewInfo = signal<CrewInfo | null>(getItemFromSessionStorage<CrewInfo>(CREW_INFO));
  private readonly _crewInfoValidated = signal<ValidateCrewInfo | null>(null);

  readonly crewInfo = this._crewInfo.asReadonly();
  readonly crewInfoValidated = this._crewInfoValidated.asReadonly();

  setCrewInfo(crewInfo: CrewInfo): void {
    setItemInSessionStorage(CREW_INFO, crewInfo);
    this._crewInfo.set(crewInfo);
  }

  setCrewInfoValidated(validated: ValidateCrewInfo): void {
    this._crewInfoValidated.set(validated);
  }

  clear(): void {
    this._crewInfo.set(null);
    this._crewInfoValidated.set(null);
  }
}
